/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 16:22:23
 */

import { API_PREFIX } from './constant'
import { Request } from './request'


// 列表
export interface RecordOfAdverseReactionListParams {
  createTimeStart?: any
  createTimeEnd?: any
  current?: any
  size?: any
  reportUserName?:any
}

export function getRecordOfAdverseReactionList(
  params: RecordOfAdverseReactionListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/adversedrugreactions/list`,
    method: 'GET',
    params,
  }
}
export interface DetailParams {
  id?: any
  tenantId?: any
}

// 详情
export function getRecordOfAdverseReactionDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/adversedrugreactions/detail`,
    method: 'GET',
    params
  }
}

// 导出
export function getRecordOfAdverseReactionExport(
  params: RecordOfAdverseReactionListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/adversedrugreactions/list/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  patientName?:any
  sex?:any
  birthDate?:any
  reportDate?:any
  reportUserName?:any
  reportUser?:any
  remark?:any
}

export function getRecordOfAdverseReactionSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/adversedrugreactions/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/adversedrugreactions/del`,
    method: 'GET',
    params: {
      ids,
    },
  }
}


